import * as React from 'react';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { grey } from '@mui/material/colors';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@emotion/react": { Global }, "@mui/material/styles": { styled }, "@mui/material/CssBaseline": CssBaseline, "@mui/material/colors": { grey }, "@mui/material/Button": Button, "@mui/material/Box": Box, "@mui/material/Skeleton": Skeleton, "@mui/material/Typography": Typography, "@mui/material/SwipeableDrawer": SwipeableDrawer } } });
export default ClientProvider;
